import type { ModuleName } from '@contexts/modules-provider';

import type { AppSideNavigationItem } from '../AppSideNavigation.types';

import { INSTRUCT_NAV } from './instruct-navigation';
import { TRAIN_NAV } from './train-navigation';

export const STATIC_MODULE_NAV: Record<
  Exclude<ModuleName, 'Manage'>,
  AppSideNavigationItem[]
> = {
  Train: TRAIN_NAV,
  Instruct: INSTRUCT_NAV,
};

export { COMMON_NAV } from './common-navigation';
